import type { Cluster } from '@googlemaps/markerclusterer';

import type { Marker } from './maps';

export type MarkerFormatter = (
  marker: Marker,
  context: { integration: 'google' }
) => HTMLDivElement;

export type ClusterMarkerFormatter = (
  marker: Marker,
  cluster: Cluster,
  context: { integration: 'google' }
) => HTMLDivElement;

export const defaultMarkerFormatter: MarkerFormatter = (
  marker,
  { integration }
) => {
  const div = document.createElement('div');
  div.className = marker.cssClass || '';

  if (integration === 'google') {
    div.classList.add('google-overlay-marker');
  }

  if (marker.markerText) {
    const textContainer = document.createElement('span');
    textContainer.textContent = marker.markerText;
    textContainer.className = 'marker-text';
    div.appendChild(textContainer);
  }

  return div;
};

export const defaultClusterMarkerFormatter: ClusterMarkerFormatter = (
  marker,
  cluster,
  { integration }
) => {
  const div = document.createElement('div');
  div.className = marker.cssClass || '';

  if (integration === 'google') {
    div.classList.add('google-overlay-cluster-marker');
  }

  const textContainer = document.createElement('span');
  textContainer.textContent = `${cluster.count}`;
  textContainer.className = 'cluster-marker-text';
  div.appendChild(textContainer);

  return div;
};
